import React, {useEffect} from 'react';
import SearchResultsSidebar from "@Sidebar/components/SearchResultsSidebar";
import {PromiseTokenProvider} from "@SearchResults/context/PromiseTokenContext";
import SearchResults from "./SearchResults";
import ErrorBoundary from "@Errors/components/ErrorBoundary";
import useSearchResultsFetcher from "@SearchResults/api/hooks/useSearchResultsFetcher";
import {useLocation} from "react-router";
import useApiRoutesFetcher from "@SearchResults/api/hooks/useApiRoutesFetcher";
import TravelInfoContainer from "@SearchResults/features/travelInfo/components/TravelInfoContainer";
import {ActiveTicketProvider} from "@Route/features/mobile/context/ActiveTicketContext";
import Form from "@Form/components/Form";
import useIsMobile from "@Hooks/selector/useIsMobile";
import useSuggestionRoutesFetcher from "@SearchResults/api/hooks/useSuggestionRoutesFetcher";
import SearchResultsPlaceholder from "@SearchResults/components/Placeholders/SearchResultsPlaceholder";
import SearchResultsError from "@SearchResults/components/SearchResultsError"

function SearchResultsContainer() {
    const searchQuery = useSearchResultsFetcher()
    useApiRoutesFetcher(searchQuery.data)
    const {suggestionRoutesEnabled} = useSuggestionRoutesFetcher(searchQuery.data)
    const params = useLocation()
    const isMobile = useIsMobile()

    // Handle navigation from check-order page
    useEffect(() => {
        // SAFETY: Check reload flag FIRST - if set, we already reloaded (prevents infinite loop)
        // This MUST be the first check to guarantee no infinite loops
        if (sessionStorage.getItem('reloadedFromCheckOrder') === '1') {
            sessionStorage.removeItem('reloadedFromCheckOrder')
            return // Exit immediately - never reload if flag exists
        }
        
        // Check if we're coming from check-order page
        const hasCheckOrderFlag = sessionStorage.getItem('isOnCheckOrder') === 'true'
        const referrerHasCheckOrder = document.referrer && document.referrer.includes('/check-order/')
        
        if (hasCheckOrderFlag || referrerHasCheckOrder) {
            sessionStorage.removeItem('isOnCheckOrder')
            
            // Check if navigation was via window.location.href (in-app back button)
            const navigatedViaLocationHref = sessionStorage.getItem('navigatedViaLocationHref') === 'true'
            
            if (!navigatedViaLocationHref) {
                // Browser back button - set flag BEFORE reload to prevent infinite loop
                sessionStorage.setItem('reloadedFromCheckOrder', '1')
                window.location.reload()
                return // Exit to prevent any further execution
            } else {
                // Navigation was via window.location.href (already did full page load)
                sessionStorage.removeItem('navigatedViaLocationHref')
            }
        }
    }, [])

    return (
        <ErrorBoundary shouldReload>
            {!isMobile && (
                <Form/>
            )}
            <div className="gb--main-content">
                {searchQuery.data && (
                    <ActiveTicketProvider singleSelectedRoute={params.state?.route}>
                        <TravelInfoContainer
                            isLoading={searchQuery.isLoading}
                            params={searchQuery.data.result.params}
                        />
                        <div className="gb--search-results__wrapper">
                            <div className="search-results_main-content">
                                <PromiseTokenProvider>
                                    <SearchResults
                                        suggestionRoutesEnabled={suggestionRoutesEnabled}
                                        searchQuery={searchQuery}
                                    />
                                </PromiseTokenProvider>
                            </div>
                            <SearchResultsSidebar
                                searchData={searchQuery.data}
                                params={searchQuery.data.result.params}
                            />
                        </div>
                    </ActiveTicketProvider>
                )}
                {(searchQuery.isLoading && !searchQuery.error) && (
                    <SearchResultsPlaceholder/>
                )}
                {searchQuery.error && (
                    <SearchResultsError
                        error={searchQuery.error}
                    />
                )}
            </div>
        </ErrorBoundary>
    );
}

export default SearchResultsContainer;